import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, switchMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from 'src/application/core/State';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import ChannelNodesReceived from '../events/ChannelNodesReceived';
import UserDetailsGetSucceed from '../../user/events/UserDetailsGetSucceed';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    return event$.pipe(
        ofType(UserDetailsGetSucceed.type),
        switchMap(() => {
            return backend.get(`${api()}channels`).pipe(
                map((ajaxResponse: AjaxResponse) => new ChannelNodesReceived(ajaxResponse.response)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            );
        })
    );
};



// WEBPACK FOOTER //
// ./src/application/products/epic/getChannelNodes.ts